import authSlice from "../slice/authSlice";
import { toast } from "react-toastify";
import { config, errToast } from "../../utils";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import { ACCOUNT, API_RESPONSE_MESSAGES } from "../../utils/constants";
import { handleSwitchAccount } from "./profileAction";
import { googleUserType, VERIFICATION_STATUS } from "../../helpers";
import { axios, axiosAuth, axiosUnauth } from "../../utils/axios/axios";
import TokenManager from "../../utils/axios/tokenManager";
import { toggleNotification } from "../slice/notificationSlice";
import setAuthToken from "../../utils/axios/setAuthToken";
import {
    handleAccountStatus,
    handleVerificationStep,
} from "./verificationAction";
import { sendNotification } from "../../components/notifications/NotificationService";
import { consumedInvitationToken } from "./buyerAction";
import { getSecretByName } from "../../redux/action/keyVaultAction";

export const authAction = authSlice.actions;

export const logout = () => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        const state = getState();
        const { access_token, user } = state.auth;
        if (access_token && user?.user_id) {
            axiosAuth.post(
                "/api-users/logout/",
                { user_id: user.user_id },
                { withCredentials: true }
            );
            const res = await axiosAuth.post(
                `/api-users/revoke-token/`,
                { token: access_token, user_id: user.user_id },
                { ...config, withCredentials: true }
            );
            const { status } = res;

            if (status === 200) {
                // Clear tokens first to prevent any refresh attempts
                const tokenManager = TokenManager.getInstance();
                await tokenManager.clearTokens();
                dispatch(authAction.logout());
                // window.location.reload();
            }
        }
        dispatch(handleSiteLoader(false));
    };
};

export const handleSiteLoader = (val) => {
    return async (dispatch) => {
        dispatch(authAction.handleSiteLoader(val));
    };
};

export const fetchToken = () => {
    return async (dispatch, getState) => {
        try {
            // console.log("i am fetch TOken");
            const tokenManager = TokenManager.getInstance();
            const validToken = await tokenManager.getValidToken();

            if (validToken) {
                const { auth } = getState();
                const profileAlreadyLoaded = !!auth.user && !auth.userLoading;

                if (!profileAlreadyLoaded) {
                    const siteId =
                        auth.user?.site_id ?? localStorage.getItem("site_id");
                    const loadUserData = {
                        ...(siteId != null && { site_id: siteId }),
                    };

                    // If we have a valid token and no profile yet, load the user
                    await dispatch(loadUser(loadUserData));
                }

                // Update Redux store with current tokens
                const { access_token } = tokenManager.getTokenData() || {};
                dispatch(
                    authAction.loadToken({
                        access_token,
                    })
                );
            } else {
                // No valid token available, logout
                dispatch(
                    authAction.loadToken({
                        access_token: "",
                        isAuthenticated: false,
                    })
                );
                dispatch(authAction.logout());
            }
        } catch (error) {
            // Network errors (no response) mean the server was unreachable — tokens
            // may still be valid, so don't log the user out for a transient failure.
            const isNetworkError = !error?.response;
            if (isNetworkError) {
                dispatch(authAction.handleSiteLoader(false));
                return;
            }
            // Token refresh failed or other error
            dispatch(
                authAction.loadToken({
                    access_token: "",
                    isAuthenticated: false,
                })
            );
            dispatch(authAction.logout());
        } finally {
            if (!getState()?.auth?.publicEncryptionKey)
                await dispatch(fetchPublicEncryptionKey());
        }
    };
};

export const handleSignUpStep = (val) => {
    return async (dispatch) => {
        dispatch(authAction.handleSignUpStep(val));
    };
};

export const registerUser = (formData, navigate) => {
    return async (dispatch, getState) => {
        const privateAuctionDetails =
            getState()?.buyer?.privateAuctionDetails ?? {};
        dispatch(authAction.handleSiteLoader(true));
        try {
            const res = await axiosUnauth.post(
                `/api-users/subdomain-registration/`,
                formData,
                { ...config, withCredentials: true }
            );
            const { data, status } = res;
            if (status === 200 && data?.error === 0) {
                //consumed the private auction token
                if (privateAuctionDetails?.token) {
                    dispatch(
                        consumedInvitationToken(privateAuctionDetails?.token)
                    );
                }

                const { login_data } = data?.data || {};
                const {
                    auth_token: { access_token },
                    user_id,
                    site_id,
                    ...rest
                } = login_data;
                // Initialize TokenManager with the new tokens
                const tokenManager = TokenManager.getInstance();
                tokenManager.setTokens({
                    access_token,
                });
                localStorage.setItem("access_token", access_token);
                localStorage.setItem("user_id", user_id);
                localStorage.setItem("site_id", site_id);
                dispatch(
                    authAction.loadUser({
                        ...rest,
                        isProcessIncomplete: true,
                        user_id,
                        site_id,
                    })
                );
                dispatch(
                    authAction.loadToken({
                        access_token,
                    })
                );

                dispatch(authAction.handleSignUpStep(4));

                // if (
                //     "account_type" in formData &&
                //     formData?.account_type === 1
                // ) {
                //     dispatch(authAction.handleSignUpStep(4));
                // } else {
                //     dispatch(handleVerificationStep(3));
                //     navigate("/verify", {
                //         state: {
                //             user: "broker",
                //         },
                //     });
                // }
                toast.success(data.msg);
            } else toast.error(data.msg);
            dispatch(authAction.handleSiteLoader(false));
            return res.data;
        } catch (err) {
            errToast(err);
            dispatch(authAction.handleSiteLoader(false));
        }
    };
};

export const login = (formData, navigate, redirectUrl = "", t) => {
    const { rememberMe, ...rest } = formData;
    return async (dispatch, getState) => {
        const privateAuctionDetails =
            getState()?.buyer?.privateAuctionDetails ?? {};
        dispatch(authAction.handleSiteLoader(true));
        try {
            const res = await axiosUnauth.post(
                `/api-users/subdomain-login/`,
                rest,
                { ...config, withCredentials: true }
            );
            const { data, status } = res;
            if (status === 200 && data?.error === 0) {
                const {
                    auth_token: { access_token },
                    user_id,
                    site_id,
                    user_type,
                    allow_notifications,
                    ...rest
                } = data.data;

                if (user_type === 1) {
                    Cookies.get("email") && Cookies.remove("email");
                    if (rememberMe) {
                        Cookies.set(
                            "email",
                            CryptoJS.AES.encrypt(
                                `${formData.email}`,
                                `${process.env.REACT_APP_ENCRYPT_DECRYPT_KEY}`
                            ).toString(),
                            { expires: 90 }
                        );

                        localStorage.setItem("access_token", access_token);
                        sessionStorage.setItem("Account", 0);
                        // setTimeout(() => navigate(redirectUrl || "/"));
                    } else {
                        sessionStorage.setItem("access_token", access_token);
                    }

                    // Initialize TokenManager with the new tokens
                    const tokenManager = TokenManager.getInstance();
                    tokenManager.setTokens({
                        access_token,
                    });

                    localStorage.setItem("user_id", user_id);
                    localStorage.setItem("site_id", site_id);
                    toast.success(t(data.msg));
                    dispatch(toggleNotification(allow_notifications));
                    dispatch(
                        authAction.loadUser({
                            ...rest,
                            user_id,
                            site_id,
                            ...(redirectUrl && {
                                isProcessIncomplete: true,
                            }),
                        })
                    );
                    dispatch(authAction.loadToken({ access_token }));
                    sessionStorage.setItem(
                        "Account",
                        redirectUrl &&
                            redirectUrl.includes(
                                "/my-properties?createAuction=true"
                            )
                            ? 1
                            : 0
                    );
                    dispatch(
                        handleSwitchAccount(
                            redirectUrl &&
                                redirectUrl.includes(
                                    "/my-properties?createAuction=true"
                                )
                                ? 1
                                : 0
                        )
                    );
                    const params = new URLSearchParams(window.location.search);

                    const redirectPath = params.get("redirect");
                    const encodedData = params.get("data");
                    let parsedState = null;

                    if (encodedData) {
                        try {
                            parsedState = JSON.parse(
                                decodeURIComponent(encodedData)
                            );
                        } catch (e) {
                            parsedState = null;
                        }
                    }

                    // consume the private auction token and wait for it, so the
                    // property access check on the redirect target already
                    // sees the invitation as consumed
                    if (privateAuctionDetails?.token) {
                        await dispatch(
                            consumedInvitationToken(privateAuctionDetails.token)
                        );
                    }

                    navigate(redirectPath || redirectUrl || "/", {
                        state: parsedState,
                        replace: true,
                    });
                } else {
                    window.location.href = `${process.env.REACT_APP_ADMIN_URL}/admin/admin-login/?token=${access_token}`;
                    return;
                }
            } else {
                toast.error(t(data.msg));
            }
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(authAction.handleSiteLoader(false));
        }
    };
};

export const loadUser = (formData) => {
    return async (dispatch) => {
        dispatch(authAction.handleSiteLoader(true));
        const tokenManager = TokenManager.getInstance();

        try {
            const res = await axiosAuth.post(
                `/api-users/user-profile-detail/`,
                formData,
                config
            );
            const { data, status } = res;
            if (status === 200 && data.error === 0) {
                if (data.msg === "User not exist.") {
                    dispatch(logout());
                    return;
                }

                const { allow_notifications, ...rest } = data.data;
                const { access_token } = tokenManager.getTokenData();
                dispatch(toggleNotification(allow_notifications));
                dispatch(authAction.loadToken({ access_token }));
                dispatch(authAction.loadUser({ ...rest, ...formData }));
                sessionStorage.getItem("Account") &&
                    dispatch(
                        handleSwitchAccount(
                            Number(sessionStorage.getItem("Account"))
                        )
                    );
            } else {
                toast.error(data.msg);
            }
            dispatch(authAction.handleSiteLoader(false));
            return res.data;
        } catch (err) {
            if (err.status === 401) {
                dispatch(logout());
                return;
            }
            errToast(err);
            dispatch(authAction.handleSiteLoader(false));
        }
    };
};

export const forgotPassword = (formData, t) => {
    return async (dispatch) => {
        dispatch(authAction.handleSiteLoader(true));
        try {
            const res = await axiosUnauth.post(
                `/api-users/subdomain-forgot-password/`,
                formData,
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data?.error === 0) {
                    dispatch(authAction.resetLinkSend(true));
                    toast.success(t(data.msg));
                } else {
                    dispatch(handleNoRemainAttempt(true));
                    toast.info(t(data.msg));
                }
            } else toast.error(t(data.msg));
            dispatch(authAction.handleSiteLoader(false));
            return res.data;
        } catch (err) {
            errToast(err);
            dispatch(authAction.handleSiteLoader(false));
        }
    };
};

export const resetLinkSend = (val) => {
    return async (dispatch) => {
        dispatch(authAction.resetLinkSend(val));
    };
};

export const resetPassword = (formData, t) => {
    return async (dispatch) => {
        dispatch(authAction.handleSiteLoader(true));
        try {
            const res = await axiosUnauth.post(
                `/api-users/subdomain-reset-password/`,
                formData,
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data?.error === 0) {
                    dispatch(authAction.resetPwdSucc(true));
                } else toast.error(t(data.msg));
            } else toast.error(t(data.msg));
            dispatch(authAction.handleSiteLoader(false));
            return res.data;
        } catch (err) {
            errToast(err);
            dispatch(authAction.handleSiteLoader(false));
        }
    };
};

export const resetPwdSucc = (val) => {
    return async (dispatch) => {
        dispatch(authAction.resetPwdSucc(val));
    };
};

export const socialLogin = (formData, navigate) => {
    return async (dispatch, getState) => {
        dispatch(authAction.handleSiteLoader(true));
        const privateAuctionDetails = getState()?.buyer?.privateAuctionDetails;
        try {
            const { data, status } = await axiosUnauth.post(
                `/api-users/social-signup/`,
                formData,
                { ...config, withCredentials: true }
            );
            const { user_id, status_id, signup_source, signup_step } =
                data?.data || {};
            if (status === 200) {
                if (status_id === 2) {
                    dispatch(handleSignUpStep(signup_step));
                    dispatch(
                        authAction.loadUser({
                            user_id,
                            status_id,
                            signup_source,
                        })
                    );
                    navigate(
                        privateAuctionDetails?.invitee_email &&
                            !privateAuctionDetails?.has_account
                            ? `/sign-up?email=${encodeURIComponent(privateAuctionDetails?.invitee_email || "")}`
                            : "/sign-up"
                    );
                } else {
                    if (data?.error === 0) {
                        const {
                            auth_token: { access_token },
                            user_id,
                            site_id,
                            user_type,
                            allow_notifications,
                            ...rest
                        } = data.data;
                        // Initialize TokenManager with the new tokens
                        if (user_type === 1) {
                            const tokenManager = TokenManager.getInstance();
                            tokenManager.setTokens({
                                access_token,
                            });
                            sessionStorage.setItem(
                                "access_token",
                                access_token || ""
                            );
                            localStorage.setItem("user_id", user_id);
                            localStorage.setItem("site_id", site_id);
                            toast.success(data.msg);
                            navigate("/");
                            dispatch(toggleNotification(allow_notifications));
                            dispatch(
                                authAction.loadUser({
                                    ...rest,
                                    user_id,
                                    site_id,
                                })
                            );
                            dispatch(
                                authAction.loadToken({
                                    access_token,
                                })
                            );
                        } else {
                            window.location.href = `${process.env.REACT_APP_ADMIN_URL}/admin/admin-login/?token=${access_token}`;
                            return;
                        }
                    } else {
                        toast.error(data.msg);
                    }
                }
            } else {
                toast.error(data.msg);
            }
            return { data, status };
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(authAction.handleSiteLoader(false));
        }
    };
};

//send otp through sms
export const sendOTP = (formData, t) => {
    return async (dispatch, getState) => {
        const {
            auth: { user },
        } = getState();
        const state = getState();
        const staticToken = process.env.REACT_APP_IS_AZURE_VAULT
            ? process.env.REACT_APP_STATIC_TOKEN
            : await dispatch(getSecretByName("WEB-AUTH-TOKEN"));
        const { phone_no: mobile_number, phone_country_code } = formData || {};
        if (Boolean(mobile_number?.startsWith(`+${phone_country_code}`))) {
            toast.error(
                t("Please enter your phone number without the country code.")
            );
            return;
        }
        dispatch(authAction.handleSiteLoader(true));
        const access_token = state.auth.access_token;
        const { signup_source, phone_no } = user || {};
        access_token && setAuthToken(staticToken, false);
        if ([googleUserType].includes(signup_source) || phone_no)
            delete formData.user_id;

        try {
            const res = await axiosUnauth({
                method: "post",
                url:
                    [googleUserType].includes(signup_source) || phone_no
                        ? `/api-users/send-otp/`
                        : `/api-users/temp-registration/`,
                data: formData,
                ...config,
            });
            const { data, status } = res;
            if (status === 200) {
                if (data?.error === 0) {
                    dispatch(
                        authAction.handleTempUserId(data?.data?.temp_user_id)
                    );
                    if (
                        data?.data?.next_step === 3 &&
                        data.msg === "Mobile Verified."
                    ) {
                        toast.info(
                            t(
                                "Mobile verification already completed for this number."
                            )
                        );
                        dispatch(authAction.handleSignUpStep(3));
                        dispatch(authAction.handleSiteLoader(false));
                        return;
                    }
                    dispatch(authAction.handleSignUpStep(2));
                    if (phone_no && phone_no !== formData?.phone_no) {
                        toast.info(
                            t(
                                "OTP sent successfully. Please verify it to complete your profile update."
                            )
                        );
                    } else {
                        toast.success(t(API_RESPONSE_MESSAGES.OtpSent));
                    }
                } else {
                    toast.info(data.msg);
                    dispatch(handleNoRemainAttempt(true));
                }
            } else toast.error(data.msg);
            access_token && setAuthToken(access_token, true);
            dispatch(authAction.handleSiteLoader(false));
            return res.data;
        } catch (err) {
            errToast(err);
            dispatch(authAction.handleSiteLoader(false));
        }
    };
};

//verify the sms otp
export const verifyOTP = (formData, t) => {
    return async (dispatch, getState) => {
        const {
            auth: { user },
        } = getState();
        dispatch(authAction.handleSiteLoader(true));
        const { signup_source } = user || {};
        try {
            const res = await axiosUnauth({
                method: "post",
                url: [googleUserType].includes(signup_source)
                    ? `/api-users/verify-otp/`
                    : `/api-users/temp-verify-otp/`,
                data: formData,
                ...config,
            });
            const { data, status } = res;
            if (status === 200 && data?.error === 0) {
                dispatch(
                    authAction.handleSignUpStep(
                        [googleUserType].includes(signup_source) ? 4 : 3
                    )
                );
                toast.success(t(data.msg));
                dispatch(authAction.handleSiteLoader(false));
                return { status, data };
            } else toast.error(t(data.msg));
            dispatch(authAction.handleSiteLoader(false));

            return res.data;
        } catch (err) {
            errToast(err);
            dispatch(authAction.handleSiteLoader(false));
        }
    };
};

export const handleNoRemainAttempt = (val) => {
    return async (dispatch) => {
        dispatch(authAction.handleNoRemainAttempt(val));
    };
};

export const handlePaymentPage = (formData) => {
    return async (dispatch) => {
        dispatch(authAction.handleSiteLoader(true));
        try {
            const { status, data } = await axiosUnauth.post(
                `/api-users/user-payment-details/`,
                formData,
                config
            );
            dispatch(authAction.handleSiteLoader(false));
            return { status, data };
        } catch (err) {
            errToast(err);
            dispatch(authAction.handleSiteLoader(false));
        }
    };
};

export const handleUserActivation = (formData, navigate, redirectUrl = "") => {
    return async (dispatch) => {
        dispatch(authAction.handleSiteLoader(true));
        try {
            const { status, data } = await axiosUnauth.post(
                `/api-users/user-activation/`,
                formData,
                { ...config, withCredentials: true }
            );
            if (status === 200) {
                if (data?.data?.auth_token) {
                    const {
                        auth_token: { access_token },
                        user_id,
                        site_id,
                        ...rest
                    } = data.data;
                    const tokenManager = TokenManager.getInstance();
                    tokenManager.setTokens({
                        access_token,
                    });
                    sessionStorage.setItem("access_token", access_token || "");
                    localStorage.setItem("user_id", user_id);
                    localStorage.setItem("site_id", site_id);
                    toast.success(data.msg);
                    dispatch(
                        authAction.loadUser({ ...rest, user_id, site_id })
                    );
                    dispatch(
                        authAction.loadToken({
                            access_token,
                        })
                    );
                    if (navigate) navigate(redirectUrl || "/");
                } else {
                    toast.error(data.msg);
                }
            } else {
                toast.error(data.msg);
            }
            dispatch(authAction.handleSiteLoader(false));
            return { status, data };
        } catch (err) {
            errToast(err);
            dispatch(authAction.handleSiteLoader(false));
        }
    };
};

export const handlePropertyStatistics = (formData) => {
    return async (dispatch) => {
        try {
            dispatch(authAction.setPropertyStatsLoading(true));
            const payload = formData ?? {};
            const response = await axiosUnauth.post(
                "/api-property/property-stat/",
                payload,
                config
            );
            const { status, data } = response || {};
            if (status === 200 && data?.error === 0) {
                dispatch(authAction.setPropertyStats(data.data));
            }
            dispatch(authAction.setPropertyStatsLoading(false));
            return { status, data };
        } catch (error) {
            errToast(error);
            dispatch(authAction.setPropertyStatsLoading(false));
        }
    };
};

let licenseAbortController = null;

export const validateLicense = (formData) => {
    return async (dispatch) => {
        try {
            if (licenseAbortController) {
                licenseAbortController.abort();
            }

            licenseAbortController = new AbortController();

            const res = await axiosUnauth.post(
                `/api-users/verify-broker-license/`,
                formData,
                {
                    signal: licenseAbortController.signal,
                }
            );

            return res.data;
        } catch (err) {
            if (err.code === "ERR_CANCELED") return null;
            errToast(err);
        }
    };
};

let checkDataAbortController = null;

export const checkData = (formData) => {
    return async () => {
        try {
            if (checkDataAbortController) {
                checkDataAbortController.abort();
            }

            checkDataAbortController = new AbortController();

            const res = await axiosUnauth.post(
                `/api-users/check-data/`,
                formData,
                {
                    signal: checkDataAbortController.signal,
                }
            );

            return res.data;
        } catch (err) {
            if (err.code === "ERR_CANCELED") return null;

            errToast(err);
        }
    };
};

export const getVerificationStatus = (journey_id, rtype) => {
    return async (dispatch, getState) => {
        try {
            const res = await axiosAuth.post(
                `/api-users/verification-idwise/`,
                { journey_id, rtype },
                config
            );

            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
        }
    };
};

export const setVerificationFlag = () => {
    return async (dispatch, getState) => {
        try {
            const res = await axiosAuth.post(
                `/api-users/reset-webhook-flag/`,
                {},
                config
            );

            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
        }
    };
};

export const sendDeleteAccountOTP = (formData, t) => {
    return async (dispatch) => {
        dispatch(authAction.handleSiteLoader(true));
        try {
            const res = await axios.post(
                `/api-users/user-delete-request/`,
                {
                    email: formData.email,
                    reason: formData.reason,
                },
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data?.error === 0) {
                    toast.success(
                        t(
                            "OTP has been sent to your email address. Please check your inbox."
                        )
                    );
                } else toast.error(t(data.msg));
            } else toast.error(t(data.msg));
            dispatch(authAction.handleSiteLoader(false));
            return res.data;
        } catch (err) {
            errToast(err);
            dispatch(authAction.handleSiteLoader(false));
        }
    };
};

export const verifyDeleteAccountOTP = (formData, t) => {
    return async (dispatch, getState) => {
        dispatch(authAction.handleSiteLoader(true));
        const isAuthenticated = getState()?.auth?.isAuthenticated;
        const userEmail = getState()?.auth?.user?.email;
        try {
            const res = await axios.delete(
                `/api-users/verify-delete/`,
                {
                    data: {
                        email: formData.email,
                        otp: formData.otp,
                    },
                },
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data?.error === 0) {
                    if (isAuthenticated && userEmail === formData.email) {
                        sessionStorage.setItem(
                            "deleteUserMsg",
                            t("Account deleted successfully.")
                        );
                        dispatch(handleSwitchAccount(ACCOUNT.Buyer));
                        dispatch(logout());
                    } else {
                        toast.success(t("Account deleted successfully."));
                    }
                } else toast.error(t(data.msg));
            } else toast.error(t(data.msg));
            dispatch(authAction.handleSiteLoader(false));
            return res.data;
        } catch (err) {
            errToast(err);
            dispatch(authAction.handleSiteLoader(false));
        }
    };
};

export const fetchPublicEncryptionKey = () => {
    return async (dispatch, getState) => {
        try {
            const isAuthenticated = getState().auth.isAuthenticated;
            const response = await (
                isAuthenticated ? axiosAuth : axiosUnauth
            ).get("/api-users/get-public-encryption-key/");
            const publicEncryptionKey =
                response?.data?.data?.public_encryption_key ?? "";
            if (response?.data?.error === 0) {
                dispatch(
                    authAction.handlePublicEncryptionKey(publicEncryptionKey)
                );
            }
            return response?.data;
        } catch (err) {
            errToast(err);
            return null;
        }
    };
};
